module.exports = __webpack_public_path__ + "img/right3 (1).e64a7058.png";